import React, { useState } from "react";
import { useParams } from "react-router-dom";

function ProcedureForm({ item, openGroPlan, setOpenGroPlan, getTreatmentPlans, matchProcedure}) {
  const { id } = useParams();

  const obj = {
    treatment_procedure_id: item.id,
    number_of_treatments: "",
    laser_level: "",
    length: "",
    protocol: "",
    fee: "",
    area: "",
  };
  const [formData, setFormData] = useState(obj);
  const [disabled,setDisabled] = useState(false)

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const submitForm = () => {
    console.log(formData);
    fetch(
      `${process.env.REACT_APP_API}/patient/${id}/treatment_plan/procedure`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
        body: JSON.stringify(formData),
      }
    )
      .then((response) => response.json())
      .then((response) => {
        if (response.success) {
          console.log("Added");
          //setOpenGroPlan(!openGroPlan)
          getTreatmentPlans()
          setDisabled(!disabled)
        }
      })
      .catch((error) => {
        console.error(error);
        //setMessage('Some Error Occured. Please Try Again Later');
      })
      .finally(() => {
        //setReady(true);
      });
  };

  return (
    <div
      style={{
        position: "absolute",
        right: "0",
        top: "50%",
        transform: "translateY(-50%)",
        backgroundColor: "rgba(246, 247, 250, 0.9)",
        height: "88.7%",
        width: "42rem",
        boxSizing: "border-box",
        padding: "2rem 1.5rem",
        textAlign: "center",
      }}
    >
      <div style={{ color: "black" }}>
        <div style={{ fontSize: "1.5rem" }}>{item.title}</div>
        <div>{item.sub_title}</div>
      </div>

      <div
        style={{
          width: "85%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          margin: "1.5rem auto",
          flexWrap: "wrap",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            flexBasis: "45%",
            margin: "0.5rem 0",
          }}
        >
          <div style={{ textAlign: "right", color: "rgba(21, 20, 20, 0.8)" }}>
            Number Of Treatments
          </div>
          <input
            type="text"
            name="number_of_treatments"
            value={formData.number_of_treatments}
            onChange={handleChange}
            style={{
              width: "8rem",
              marginLeft: "1rem",
              outline: "none",
              border: "none",
              padding: "0.2rem 0.5rem",
              background: "rgba(246, 247, 250, 0.5)",
              textAlign: "center",
              color: "black",
              fontWeight: "bold",
            }}
          />
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            flexBasis: "45%",
            margin: "0.5rem 0",
          }}
        >
          <div style={{ textAlign: "right", color: "rgba(21, 20, 20, 0.8)" }}>
            Laser Level
          </div>
          <input
            type="text"
            name="laser_level"
            value={formData.laser_level}
            onChange={handleChange}
            style={{
              width: "8rem",
              marginLeft: "1rem",
              outline: "none",
              border: "none",
              padding: "0.2rem 0.5rem",
              background: "rgba(246, 247, 250, 0.5)",
              textAlign: "center",
              color: "black",
              fontWeight: "bold",
            }}
          />
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            flexBasis: "45%",
            margin: "0.5rem 0",
          }}
        >
          <div style={{ textAlign: "right", color: "rgba(21, 20, 20, 0.8)" }}>
            Length
          </div>
          <input
            type="text"
            name="length"
            value={formData.length}
            onChange={handleChange}
            style={{
              width: "8rem",
              marginLeft: "1rem",
              outline: "none",
              border: "none",
              padding: "0.2rem 0.5rem",
              background: "rgba(246, 247, 250, 0.5)",
              textAlign: "center",
              color: "black",
              fontWeight: "bold",
            }}
          />
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            flexBasis: "45%",
            margin: "0.5rem 0",
          }}
        >
          <div style={{ textAlign: "right", color: "rgba(21, 20, 20, 0.8)" }}>
            Protocol
          </div>
          <input
            type="text"
            name="protocol"
            value={formData.protocol}
            onChange={handleChange}
            style={{
              width: "8rem",
              marginLeft: "1rem",
              outline: "none",
              border: "none",
              padding: "0.2rem 0.5rem",
              background: "rgba(246, 247, 250, 0.5)",
              textAlign: "center",
              color: "black",
              fontWeight: "bold",
            }}
          />
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            flexBasis: "45%",
            margin: "0.5rem 0",
          }}
        >
          <div style={{ textAlign: "right", color: "rgba(21, 20, 20, 0.8)" }}>
            Fee
          </div>
          <input
            type="text"
            name="fee"
            value={formData.fee}
            onChange={handleChange}
            style={{
              width: "8rem",
              marginLeft: "1rem",
              outline: "none",
              border: "none",
              padding: "0.2rem 0.5rem",
              background: "rgba(246, 247, 250, 0.5)",
              textAlign: "center",
              color: "black",
              fontWeight: "bold",
            }}
          />
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            flexBasis: "45%",
            margin: "0.5rem 0",
          }}
        >
          <div style={{ textAlign: "right", color: "rgba(21, 20, 20, 0.8)" }}>
            Treatment Areas
          </div>
          <input
            type="text"
            name="area"
            value={formData.area}
            onChange={handleChange}
            style={{
              width: "8rem",
              marginLeft: "1rem",
              outline: "none",
              border: "none",
              padding: "0.2rem 0.5rem",
              background: "rgba(246, 247, 250, 0.5)",
              textAlign: "center",
              color: "black",
              fontWeight: "bold",
            }}
          />
        </div>
      </div>
      <div style={{ textAlign: "center", marginTop: "5rem" }}>
        <button
          onClick={submitForm}
          disabled={disabled}
          style={{
            marginRight: "4rem",
            background: "#3BACA1",
            borderRadius: "5px",
            color: "white",
            padding: "0.2rem 1rem",
          }}
        >
          {disabled ? "Added to GRO plan" : "Add to GRO plan"}
        </button>
        <button
          style={{
            background: "#3BACA1",
            borderRadius: "5px",
            color: "white",
            padding: "0.2rem 1rem",
          }}
        >
          Purchase Now
        </button>
      </div>
    </div>
  );
}

export default ProcedureForm;
